(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.qim = global.qim || {})));
}(this, (function (exports) { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};



















var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};



































var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var selectKey = '@@qim/navSelect';
var updateKey = '@@qim/navUpdate';

var $traverse = function $traverse(spec) {
  var _ref2;

  if (typeof spec === 'function') {
    var _ref;

    return _ref = {}, defineProperty(_ref, selectKey, function (object, next, path, index) {
      return spec('select', object, next, path, index);
    }), defineProperty(_ref, updateKey, function (object, next, path, index) {
      return spec('update', object, next, path, index);
    }), _ref;
  }
  return _ref2 = {}, defineProperty(_ref2, selectKey, spec.select), defineProperty(_ref2, updateKey, spec.update), _ref2;
};

// Yes, we could make a smple universal curry with `.reduce`, but this is
// faster.

var curry2 = function curry2(fn) {
  return function (a, b, sourceObj) {
    switch (arguments.length) {
      case 2:
        return fn(a, b, sourceObj);
      case 1:
        return function (_b, _sourceObj) {
          return fn(a, _b, _sourceObj);
        };
      default:
        return fn;
    }
  };
};

var curry3 = function curry3(fn) {
  return function (a, b, c, sourceObj) {
    switch (arguments.length) {
      case 3:
        return fn(a, b, c, sourceObj);
      case 2:
        return function (_c, _sourceObj) {
          return fn(a, b, _c, _sourceObj);
        };
      case 1:
        return curry2(function (_b, _c, _sourceObj) {
          return fn(a, _b, _c, _sourceObj);
        });
      default:
        return fn;
    }
  };
};

var arrayify = function arrayify(value) {
  return Array.isArray(value) ? value : [value];
};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var index = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var copy = function copy(object) {
  return Array.isArray(object) ? object.slice(0) : index({}, object);
};

var pathKey = '@@qim/navPath';

var $nav = function $nav(path) {
  if (typeof path !== 'function' && !Array.isArray(path)) {
    if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object') {
      throw new Error('Function or array or primitive is required to create a path navigator.');
    }
    path = [path];
  }
  var nav = defineProperty({}, pathKey, path);
  nav.self = nav;
  if (arguments.length > 1) {
    var moreNavPaths = [];
    for (var i = 1; i < arguments.length; i++) {
      path = arguments[i];
      if (typeof path !== 'function' && !Array.isArray(path)) {
        if ((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object') {
          throw new Error('Function or array or primitive is required to create a path navigator.');
        }
        path = [path];
      }
      moreNavPaths.push(path);
    }
    nav.moreNavPaths = moreNavPaths;
  }
  return nav;
};

var $setKey = '@@qim/$setKey';

var $set = function $set(value) {
  return { '@@qim/nav': $setKey, value: value };
};

var $defaultKey = '@@qim/$defaultKey';

var $default = function $default(value) {
  return { '@@qim/nav': $defaultKey, value: value };
};

var $applyKey = '@@qim/$apply';

var $apply = function $apply(fn) {
  return { '@@qim/nav': $applyKey, fn: fn };
};

var $lensKey = '@@qim/$lens';

var $lens = function $lens(fn, fromFn) {
  return { '@@qim/nav': $lensKey, fn: fn, fromFn: fromFn };
};

var $setContextKey = '@@qim/$setContext';

var setContext = function setContext(nav, value, context) {
  context = index({}, context);
  context[nav.key] = value;
  return context;
};

var identity = function identity(v) {
  return v;
};

var $setContext = function $setContext(key) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  return { '@@qim/nav': $setContextKey, setContext: setContext, key: key, fn: fn };
};

var $noneKey = '@@qim/$noneKey';

var $none = { '@@qim/nav': $noneKey };

var isNone = function isNone(value) {
  return value && value['@@qim/nav'] === $noneKey;
};

var undefinedIfNone = function undefinedIfNone(value) {
  return isNone(value) ? undefined : value;
};

// There's not really any compatibility between `qim` and transducers, but since
// transducers already had a "reduced" concept, it seemed appropriate to use
// that convention.

// When looping through object or array values, `reduced` is used to tell the
// loop that the loop is finished.
var reduced = function reduced(value) {
  return {
    '@@transducer/reduced': true,
    '@@transducer/value': value
  };
};

var isReduced = function isReduced(value) {
  return value && !!value['@@transducer/reduced'];
};

// Unwrap a reduced value if necessary.
var unreduced = function unreduced(value) {
  return isReduced(value) ? value['@@transducer/value'] : value;
};

// `traverseEach` is the heart of `qim`. It's a little ugly because it needs to
// be performant, and it's generic across select and update.
var traverseEach = function traverseEach(navKey, // select or update?
state, // state to carry around, so select can add new values
resultFn, // like a reduce function, called for each selected value
path, // the whole query
object, // the current object that we're traversing
pathIndex, // index into the path
returnFn, // function to "return" to, if we've navigated into a sub-query
context, // current context: modified with setContext and passed to transforms
mutationMarker // performance signal that it's safe to mutate instead of clone
) {

  if (pathIndex >= path.length) {
    // If we're in a sub-query (with $nav), we need to return.
    if (returnFn) {
      return returnFn(object, context);
    }
    // Default to identity if there's no result function.
    return resultFn ? resultFn(state, object) : object;
  }

  var nav = path[pathIndex];

  // null/undefined selects/updates nothing.
  if (nav == null) {
    return navKey === selectKey ? $none : object;
  }

  // Primitives are handled right here inside traverseEach to stay efficient.
  if (typeof nav === 'string' || typeof nav === 'number' || typeof nav === 'boolean') {
    // select, which is pretty simple
    if (navKey === selectKey) {
      // If we have an object, just grab the nested object and keep digging.
      if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object') {
        var subObject = object[nav];
        // Special case so `has` can differentiate between missing keys and keys
        // pointing to undefined values. Maybe a better way? Maybe just don't
        // worry about `has(['x'], {x: undefined}) === false`?
        if (typeof subObject === 'undefined' && !(nav in object) && pathIndex === path.length - 1) {
          return $none;
        }
        return traverseEach(navKey, state, resultFn, path, subObject, pathIndex + 1, returnFn, context);
      } else {
        return $none;
      }
    }
    // update, which is not as simple
    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object') {
      var value = object[nav];
      // Dig in for the new value.
      var newValue = traverseEach(navKey, state, resultFn, path, value, pathIndex + 1, returnFn, context);
      // A new value of $none means we've removed it.
      if (isNone(newValue)) {
        if (!(nav in object)) {
          return object;
        }
        if (Array.isArray(object)) {
          var _newObject2 = object.slice(0);
          // Could have a silly edge here where nav was a property and not an
          // index, which means it disappears. If it's still here, that means
          // it's an index.
          if (nav in object) {
            _newObject2.splice(nav, 1);
          }
          return _newObject2;
        }
        var _newObject = index({}, object);
        delete _newObject[nav];
        return _newObject;
      }
      // If we got back the same value, it's a no-op.
      if (value === newValue) {
        return object;
      }
      // Some dangerous mutation going on here! Be careful!
      if (mutationMarker) {
        // If we have a mutation marker, and we've already mutated, then we can
        // safely mutate and avoid the cost of re-cloning the object.
        if (mutationMarker.hasMutated) {
          object[nav] = newValue;
          return object;
          // Otherwise, we're going to mutate, so mark that we've mutated.
        } else {
          mutationMarker.hasMutated = true;
        }
      }
      // Clone our object and set the property to the new value.
      var newObject = copy(object);
      newObject[nav] = newValue;
      return newObject;
      // If we got back null/undefined, then intelligently create a new object.
      // It's debatable on whether or not this is a good idea. Integers used to
      // auto-create arrays, but that's probably wrong more than right. An
      // integer like 123456 is probably an id and not an array index, so it's
      // probably a mistake to create an array of that size. If an array is
      // actually wanted, `default([])` can be added. We could do nothing, which
      // would keep you from making typos, but then you have to add a lot of
      // `default({})`, and then you're right back to being able to make typos.
      // So defaulting to create an object seems like a sane balance.
    } else if (object == null) {
      var _newValue = traverseEach(navKey, state, resultFn, path, undefined, pathIndex + 1, returnFn, context);
      // Trying to set a key to $none is a no-op.
      if (isNone(_newValue)) {
        return object;
      }
      var _newObject3 = {};
      _newObject3[nav] = _newValue;
      return _newObject3;
    } else {
      throw new Error('Cannot update property ' + nav + ' (at path index ' + pathIndex + ') for non-object.');
    }
  }

  // Predicate navigator, keep going if there's a match.
  if (typeof nav === 'function') {
    if (nav(object)) {
      return traverseEach(navKey, state, resultFn, path, object, pathIndex + 1, returnFn, context);
    } else {
      return navKey === selectKey ? $none : object;
    }
  }

  // Some built-in navigators for transform and context.
  switch (nav['@@qim/nav']) {
    // Transform the current value into another value.
    case $applyKey:
      {
        return traverseEach(navKey, state, resultFn, path, nav.fn(object, context), pathIndex + 1, returnFn, context);
      }
    // Transform the current value into another value.
    // For updates, apply another transform on the way back.
    case $lensKey:
      {
        var result = traverseEach(navKey, state, resultFn, path, nav.fn(object, context), pathIndex + 1, returnFn, context);
        if (navKey === selectKey || !nav.fromFn) {
          return result;
        }
        return nav.fromFn(result, object, context);
      }
    // Set the current value to a new constant value.
    case $setKey:
      return traverseEach(navKey, state, resultFn, path, nav.value, pathIndex + 1, returnFn, context);
    // Set the current value to a new constant value if the current value is
    // undefined.
    case $defaultKey:
      {
        if (typeof object === 'undefined') {
          return traverseEach(navKey, state, resultFn, path, nav.value, pathIndex + 1, returnFn, context);
        }
        return traverseEach(navKey, state, resultFn, path, object, pathIndex + 1, returnFn, context);
      }
    // Remove the current value.
    case $noneKey:
      return $none;
    // Set a context value, to later be used by $apply.
    case $setContextKey:
      {
        context = nav.setContext(nav, nav.fn(object, context || {}), context);
        return traverseEach(navKey, state, resultFn, path, object, pathIndex + 1, returnFn, context);
      }
  }

  var navPath = nav[pathKey];

  // TODO: Combine this with array navigator.
  // Path navigators.
  if (navPath) {
    // A path navigator can potentially go down multiple paths.
    var moreNavPaths = nav.moreNavPaths;
    var moreNavPathsIndex = 0;
    var navResult = object;
    do {
      // If it's a function, get our path dynamically.
      if (typeof navPath === 'function') {
        navPath = nav.hasArgs ? navPath(nav.args, object, context) : navPath(object, context);
        navPath = arrayify(navPath);
      }
      // TODO: Use mutationMarker.
      // An empty query just means continue.
      if (navPath.length === 0) {
        navResult = traverseEach(navKey, state, resultFn, path, object, pathIndex + 1, returnFn, context);
        // Otherwise, recurse in with our new query, but pass a `returnFn` so we can
        // continue where we left off.
      } else {
        navResult = traverseEach(navKey, state, resultFn, navPath, object, 0, function (_object, _context) {
          return traverseEach(navKey, state, resultFn, path, _object, pathIndex + 1, returnFn, _context);
        }, context);
      }
      if (moreNavPaths) {
        // Selects should be applied to the same object, since nothing has changed. If we've reduced, then we're done.
        if (navKey === selectKey) {
          if (isReduced(navResult)) {
            return navResult;
          }
          // Updates should be applied to the new object.
        } else {
          object = undefinedIfNone(navResult);
        }
        navPath = moreNavPaths[moreNavPathsIndex];
        moreNavPathsIndex++;
      } else {
        navPath = undefined;
      }
    } while (navPath);
    return navResult;
  }

  // Core select/update navigator.
  if (nav[navKey]) {
    if (nav.hasArgs) {
      return nav[navKey](nav.args, object, function (subObject) {
        return traverseEach(navKey, state, resultFn, path, subObject, pathIndex + 1, returnFn, context);
      }, path, pathIndex);
    }
    return nav[navKey](object, function (subObject) {
      return traverseEach(navKey, state, resultFn, path, subObject, pathIndex + 1, returnFn, context);
    }, path, pathIndex);
  }

  // Nested sub-query.
  if (Array.isArray(nav)) {
    // A nested select will branch off an add items to the current select state.
    // So it's semantically a bit different than a nested update sub-query.
    if (navKey === selectKey) {
      var subResult = traverseEach(navKey, state, resultFn, nav, object, 0, returnFn, context);
      if (pathIndex + 1 === path.length) {
        return subResult;
      }
      return traverseEach(navKey, state, resultFn, path, object, pathIndex + 1, returnFn, context);
    }

    // A nested update will branch off and mutate the object and then return to
    // the current object. It's kind of just a fancy $apply.
    // Create a mutation marker so we can efficiently apply many sub-queries to
    // the current object.
    mutationMarker = mutationMarker || {
      hasMutated: false
    };
    var nestedResult = undefinedIfNone(traverseEach(navKey, state, resultFn, nav, object, 0, undefined, context, mutationMarker));
    return traverseEach(navKey, state, resultFn, path, nestedResult, pathIndex + 1, returnFn, context, mutationMarker);
  }

  throw new Error('Invalid navigator ' + nav + ' at path index ' + pathIndex + '.');
};

// select is just a traverse that pushes each result onto an array.
var selectResultFn = function selectResultFn(state, result) {
  state.push(result);
  return state;
};

var select = function select(path, object) {
  if (path == null) {
    return [];
  }
  path = arrayify(path);
  var result = [];
  traverseEach(selectKey, result, selectResultFn, path, object, 0);
  return result;
};

var select$1 = curry2(select);

// find is a select that returns a "reduced" envelope as soon as it selects
// anything.
var selectFirstResultFn = function selectFirstResultFn(state, result) {
  return reduced(result);
};

var find = function find(path, obj) {

  var pathIndex = 0;
  var key = void 0;

  if (!Array.isArray(path)) {
    path = [path];
  }

  // We'll just use an optimized while loop as long as we have simple primitive
  // navigators.
  while (pathIndex < path.length) {
    key = path[pathIndex];
    // If we have a non-primitive navigator, we'll switch over to a generic
    // traverse.
    if (key && typeof key !== 'string' && typeof key !== 'number' && typeof key !== 'boolean') {
      var selectResult = unreduced(traverseEach(selectKey, null, selectFirstResultFn, path, obj, pathIndex));
      return isNone(selectResult) ? undefined : selectResult;
    }
    if (obj == null) {
      obj = undefined;
      break;
    }
    obj = obj[key];
    pathIndex++;
  }

  return obj;
};

var find$1 = curry2(find);

// has uses the same reduced envelope as find.
var selectFirstResultFn$1 = function selectFirstResultFn(state, result) {
  return reduced(result);
};

var has = function has(path, obj) {

  var pathIndex = 0;
  var key = void 0;
  var parentObj = void 0;

  if (!Array.isArray(path)) {
    path = [path];
  }

  // We'll just use an optimized while loop as long as we have simple primitive
  // navigators.
  while (pathIndex < path.length) {
    key = path[pathIndex];
    // If we have a non-primitive navigator, we'll switch over to a generic
    // traverse.
    if (key && typeof key !== 'string' && typeof key !== 'number' && typeof key !== 'boolean') {
      var selectResult = traverseEach(selectKey, null, selectFirstResultFn$1, path, obj, pathIndex);
      if (typeof selectResult === 'undefined') {
        return false;
      }
      selectResult = unreduced(selectResult);
      return isNone(selectResult) ? false : true;
    }
    if (obj == null) {
      return false;
    }
    parentObj = obj;
    obj = obj[key];
    pathIndex++;
  }

  if (typeof obj === 'undefined') {
    if (path.length === 0) {
      return true;
    }
    if (!parentObj || (typeof parentObj === 'undefined' ? 'undefined' : _typeof(parentObj)) !== 'object' || !(key in parentObj)) {
      return false;
    }
  }

  return true;
};

var has$1 = curry2(has);

// update is a traverse that has no state or result function.
var update = function update(path, obj) {
  return path == null ? obj : undefinedIfNone(traverseEach(updateKey, undefined, undefined, arrayify(path), obj, 0));
};

var update$1 = curry2(update);

var set$1 = function set$$1(path, value, obj) {

  // Optimized case for a single primitive key.
  if (!path || (typeof path === 'undefined' ? 'undefined' : _typeof(path)) !== 'object') {
    if (obj == null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
      return obj;
    }

    if (obj[path] === value) {
      return obj;
    }

    obj = copy(obj);

    obj[path] = value;

    return obj;
  }

  path = Array.isArray(path) ? path : [path];

  return undefinedIfNone(traverseEach(updateKey, undefined, undefined, path, obj, 0, function () {
    return value;
  }));
};

var set$2 = curry3(set$1);

var apply = function apply(path, transform, obj) {
  path = Array.isArray(path) ? path : [path];
  return undefinedIfNone(traverseEach(updateKey, undefined, undefined, path, obj, 0, transform));
};

var apply$1 = curry3(apply);

var pluralize = function pluralize(type) {
  return type + 's';
};

var typeName = function typeName(object) {
  if (object === null) {
    return 'null';
  }
  if (Array.isArray(object)) {
    return 'array';
  }
  return typeof object === 'undefined' ? 'undefined' : _typeof(object);
};

// Prepend word with "a" or "an".
var articleize = function articleize(type) {
  return ('aeiou'.indexOf(type[0]) >= 0 ? 'an' : 'a') + ' ' + type;
};

// Concatenate types together into a phrase.
var getSupportedTypesPhrase = function getSupportedTypesPhrase(supportedTypes) {
  supportedTypes = Array.isArray(supportedTypes) ? supportedTypes : [supportedTypes];
  var pluralTypes = supportedTypes.map(function (type) {
    return pluralize(type);
  });

  if (pluralTypes.length === 1) {
    return pluralTypes[0];
  }

  if (pluralTypes.length === 2) {
    return pluralTypes[0] + ' and ' + pluralTypes[1];
  }

  return pluralTypes.slice(0, pluralTypes.length - 1).join(', ').concat(', and ' + pluralTypes[pluralTypes.length - 1]);
};

// Get error message saying what types a function supports.
var getTypeErrorMessage = function getTypeErrorMessage(name, supportedTypes, object) {
  return [name, ' only supports ', getSupportedTypesPhrase(supportedTypes), ', but ', articleize(typeName(object)), ' was provided.'].join('');
};

var reduceSequence = function reduceSequence(eachFn, initialValue, seq) {
  var result = initialValue;
  if (Array.isArray(seq)) {
    for (var i = 0; i < seq.length; i++) {
      result = eachFn(result, i);
      if (isReduced(result)) {
        return result;
      }
    }
  } else if (seq !== null && (typeof seq === 'undefined' ? 'undefined' : _typeof(seq)) === 'object') {
    for (var key in seq) {
      if (seq.hasOwnProperty(key)) {
        result = eachFn(result, key);
        if (isReduced(result)) {
          return result;
        }
      }
    }
  } else {
    throw new Error(getTypeErrorMessage('reduceSequence', ['object', 'array'], seq));
  }
  return result;
};

// When an item is removed from an array or object, `removed` is used to mark
// it as being removed. This is useful, for example, so that we can remove an
// item inside a loop without affecting the affecting the item count. We could
// use $none for this, but `removed` specifically exists to allow you to store
// $none in an array/object and still have `qim` work correctly. So what if you
// want to store `removed` in your array/object? That's just silly. :-P
var removed = {
  '@@qim/removed': true
};



var isNotRemoved = function isNotRemoved(value) {
  return !value || !value['@@qim/removed'];
};

var $each = $traverse({
  select: function select(object, next) {
    // Pass each value along to the next navigator.
    return reduceSequence(function (result, key) {
      return next(object[key]);
    }, undefined, object);
  },
  update: function update(object, next) {
    var isArray = Array.isArray(object);
    // Marker for if we removed values from an array. Since we filter out
    // removed values, we don't want to do that iteration if we don't have to.
    // Maybe there's a better way to do this, but removing array values in place
    // is kind of ugly, since positions change.
    var didRemoveValues = false;
    var newObject = reduceSequence(function (result, key) {
      var newValue = next(object[key]);
      var isNewValueNone = isNone(newValue);
      // This is a no-op unless we actually have a different value. The
      // `isNoneValue` covers a goofy edge where you might have the value $none
      // stored in the object/array. In that case, it would match, but we still
      // want to remove it.
      if (newValue !== object[key] || isNewValueNone) {
        // Create a new object if we haven't done that yet.
        if (object === result) {
          result = copy(result);
        }

        if (isNewValueNone) {
          // For arrays, we'll store a removed value so indexes don't get wonky.
          if (isArray) {
            result[key] = removed;
            didRemoveValues = true;
            // Otherwise, we'll just delete it now.
          } else {
            delete result[key];
          }
        } else {
          result[key] = newValue;
        }
      }
      return result;
    }, object, object);
    // Filter our removed values from arrays.
    if (isArray && didRemoveValues) {
      return newObject.filter(isNotRemoved);
    }
    return newObject;
  }
});

var $eachKey = $traverse({
  select: function select(object, next) {
    // Pass each key along to the next navigator.
    return reduceSequence(function (result, key) {
      return next(key);
    }, undefined, object);
  },
  update: function update(object, next) {
    var isArray = Array.isArray(object);
    // Marker for if we removed keys from an array. Since we filter out
    // removed keys, we don't want to do that iteration if we don't have to.
    // Maybe there's a better way to do this, but removing array values in place
    // is kind of ugly, since positions change.
    var didRemoveKeys = false;
    var newObject = reduceSequence(function (result, key) {
      var newKey = next(key);
      // Undefined/null key doesn't make much sense, so treat it as $none.
      var isKeyNone = isNone(newKey) || newKey == null;
      // Marker for if we removed values from an array. Since we filter out
      // removed values, we don't want to do that iteration if we don't have to.
      // Maybe there's a better way to do this, but removing array values in place
      // is kind of ugly, since positions change.
      didRemoveKeys = didRemoveKeys || isKeyNone;
      // This is a no-op unless we actually have a different key.
      if (newKey !== key) {
        // Create a new object if we haven't done that yet.
        if (object === result) {
          result = copy(result);
        }
        // For arrays, we'll store a removed value so indexes don't get wonky.
        if (isArray) {
          result[key] = removed;
          didRemoveKeys = true;
          // Otherwise, we'll just delete it now.
        } else {
          delete result[key];
        }
        // If we have a new key, point the new key to the value of the old key.
        if (!isKeyNone) {
          result[newKey] = object[key];
        }
      }
      return result;
    }, object, object);
    // Filter our removed values from arrays.
    if (isArray && didRemoveKeys) {
      return newObject.filter(isNotRemoved);
    }
    return newObject;
  }
});

var $eachPair = $traverse({
  select: function select(object, next) {
    // Pass each pair along to the next navigator.
    return reduceSequence(function (result, key) {
      return next([key, object[key]]);
    }, undefined, object);
  },
  update: function update(object, next) {
    var isArray = Array.isArray(object);
    // Marker for if we removed pairs from an array. Since we filter out
    // removed pairs, we don't want to do that iteration if we don't have to.
    // Maybe there's a better way to do this, but removing array values in place
    // is kind of ugly, since positions change.
    var didRemovePairs = false;
    var newObject = reduceSequence(function (result, key) {
      var value = object[key];
      var pair = [key, value];
      var newPair = next(pair);
      var newKey = void 0;
      var newValue = void 0;
      // Undefined/null pair will result in undefined key, which will be
      // treated as $none.
      if (newPair != null) {
        newKey = newPair[0];
        newValue = newPair[1];
      }
      var isPairNone =
      // Undefined/null key doesn't make much sense, so treat it as $none.
      newKey == null || isNone(newPair) ||
      // isNone(newValue) covers a goofy edge where you might have the value
      // $none stored in an object/array. In that case, it would match, but we
      // still want to remove it.
      isNone(newValue);
      // This is a no-op unless we actually have a different value or key.
      if (newKey !== key || newValue !== value || isPairNone) {
        // Create a new object if we haven't done that yet.
        if (object === result) {
          result = copy(result);
        }
        if (newKey !== key) {
          // For arrays, we'll store a removed value so indexes don't get wonky.
          if (isArray) {
            result[key] = removed;
            didRemovePairs = true;
            // Otherwise, we'll just delete it now.
          } else {
            delete result[key];
          }
        }
        // If we haven't removed the key or value, then set the new key to the
        // new value.
        if (!isPairNone) {
          result[newKey] = newValue;
        }
      }
      return result;
    }, object, object);
    // Filter our removed values from arrays.
    if (isArray && didRemovePairs) {
      return newObject.filter(isNotRemoved);
    }
    return newObject;
  }
});

var createMerge = function createMerge() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isDeep = _ref.isDeep,
      isDeep = _ref$isDeep === undefined ? false : _ref$isDeep;

  var isShallow = !isDeep;
  var merge = function merge(spec, object) {
    if (spec && (typeof spec === 'undefined' ? 'undefined' : _typeof(spec)) === 'object' && object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object') {
      var newObject = object;
      for (var key in spec) {
        if (spec.hasOwnProperty(key)) {
          var mergeValue = isShallow ? spec[key] : merge(spec[key], object[key]);
          if (newObject[key] !== mergeValue) {
            // Create a new object if we haven't done that yet.
            if (newObject === object) {
              newObject = copy(object);
            }
            newObject[key] = mergeValue;
          }
        }
      }
      return newObject;
    }
    return spec;
  };
  return merge;
};

var merge = createMerge();

var $merge = function $merge(spec) {
  return $traverse(function (type, object, next) {
    return next(merge(spec, object));
  });
};

var mergeDeep = createMerge({ isDeep: true });

var $mergeDeep = function $mergeDeep(spec) {
  return $traverse(function (type, object, next) {
    return next(mergeDeep(spec, object));
  });
};

var $begin = $traverse({
  select: function select(object, next) {
    if (Array.isArray(object)) {
      return next([]);
    }
    throw new Error(getTypeErrorMessage('$begin', 'array', object));
  },
  update: function update(object, next) {
    if (Array.isArray(object)) {
      var beginArray = next([]);
      if (beginArray && beginArray.length === 0) {
        return object;
      }
      if (!beginArray || typeof beginArray === 'string' || typeof beginArray.concat !== 'function') {
        return [beginArray].concat(object);
      }
      return beginArray.concat(object);
    }
    throw new Error(getTypeErrorMessage('$begin', 'array', object));
  }
});

var $end = $traverse({
  select: function select(object, next) {
    if (Array.isArray(object)) {
      return next([]);
    }
    throw new Error(getTypeErrorMessage('$end', 'array', object));
  },
  update: function update(object, next) {
    if (Array.isArray(object)) {
      var endArray = next([]);
      if (endArray && endArray.length === 0) {
        return object;
      }
      return object.concat(endArray);
    }
    throw new Error(getTypeErrorMessage('$end', 'array', object));
  }
});

// Special purpose utility to look at the current path and index and determine
// if the next navigator is a constant value. This is so a navigator can
// "cheat" a little and lookahead to determine if its value will actually be
// used. If not, the navigator can avoid calculating its own value.
var isNextNavigatorConstant = (function (path, index) {
  if (index + 1 < path.length) {
    var nextNav = path[index + 1];
    if (nextNav) {
      var navKey = nextNav['@@qim/nav'];
      if (navKey === $noneKey || navKey === $setKey) {
        return true;
      }
    }
  }
  return false;
});

var eachArg = function eachArg(fn, args, object) {
  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (Array.isArray(arg)) {
      for (var j = 0; j < arg.length; j++) {
        var subArg = arg[j];
        if (subArg in object) {
          fn(subArg);
        }
      }
    } else {
      if (arg in object) {
        fn(arg);
      }
    }
  }
};

var $pick = function $pick() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return $traverse({
    select: function select(object, next) {
      var picked = {};
      eachArg(function (key) {
        picked[key] = object[key];
      }, args, object);
      return next(picked);
    },
    update: function update(object, next, path, index$$1) {
      // Is it worth avoiding cloning if nothing changes?
      var newObject = copy(object);
      // We cheat a little and look ahead to see if `next` is going to return
      // a constant. If it is, then there's no reason to get a proper pick of
      // the object, because we know it won't be used anyway.
      // CONSIDER THIS AN EXPERIMENT. DON'T USE IT IN YOUR NAVIGATORS.
      if (isNextNavigatorConstant(path, index$$1)) {
        (function () {
          // Call `next` with no args, because it's a constant.
          var newPicked = next();
          if (isNone(newPicked) || newPicked == null) {
            // Delete all picked keys.
            eachArg(function (key) {
              delete newObject[key];
            });
          } else {
            if ((typeof newPicked === 'undefined' ? 'undefined' : _typeof(newPicked)) !== 'object') {
              throw new Error('$pick expected next navigator to return an object. Did you forget $each?');
            }
            // Delete any removed properties.
            eachArg(function (key) {
              if (!(key in newPicked)) {
                delete newObject[key];
              }
            }, args, object);
            // Mix in the new properties.
            index(newObject, newPicked);
          }
          // Otherwise, we do have to slice the array so it can be passed to `next`.
        })();
      } else {
        (function () {
          var pickedKeys = [];
          var picked = {};
          eachArg(function (key) {
            pickedKeys.push(key);
            picked[key] = object[key];
          }, args, object);
          var newPicked = next(picked);
          if (isNone(newPicked) || newPicked == null) {
            // Delete all picked keys
            pickedKeys.forEach(function (key) {
              delete newObject[key];
            });
          } else {
            if ((typeof newPicked === 'undefined' ? 'undefined' : _typeof(newPicked)) !== 'object') {
              throw new Error('$pick expected next navigator to return an object. Did you forget $each?');
            }
            // Delete any removed properties.
            pickedKeys.forEach(function (key) {
              if (!(key in newPicked)) {
                delete newObject[key];
              }
            });
            // Mix in the new properties.
            index(newObject, newPicked);
          }
        })();
      }
      return newObject;
    }
  });
};

var normalizeIndex = function normalizeIndex(index, count, defaultIndex) {
  if (index === undefined) {
    return defaultIndex;
  }
  if (index < 0) {
    if (count === Infinity) {
      return count;
    }
    return Math.max(0, count + index) | 0;
  }
  if (count === undefined || count === index) {
    return index;
  }
  return Math.min(count, index) | 0;
};

var $slice = function $slice(begin, end) {
  return $traverse({
    select: function select(object, next) {
      if (object && typeof object.slice === 'function') {
        var spliceBegin = normalizeIndex(begin, object.length, 0);
        var spliceEnd = normalizeIndex(end, object.length, object.length);
        return next(object.slice(spliceBegin, spliceEnd));
      }
      throw new Error(getTypeErrorMessage('$slice', 'array', object));
    },
    update: function update(object, next, path, index) {
      // Is it worth avoiding cloning if nothing changes?
      if (object && typeof object.slice === 'function') {
        var newArray = object.slice(0);
        var spliceBegin = normalizeIndex(begin, object.length, 0);
        var spliceEnd = normalizeIndex(end, object.length, object.length);
        // We cheat a little and look ahead to see if `next` is going to return
        // a constant. If it is, then there's no reason to get a proper slice of
        // the array, because we know it won't be used anyway.
        // CONSIDER THIS AN EXPERIMENT. DON'T USE IT IN YOUR NAVIGATORS.
        // It actually doesn't seem to help that much unless the slice is huge.
        if (isNextNavigatorConstant(path, index)) {
          // Call `next` with no args, because it's a constant.
          var newSlice = next();
          // Splice in the new array.
          newArray.splice.apply(newArray, [spliceBegin, spliceEnd - spliceBegin].concat(toConsumableArray(newSlice)));
          // Otherwise, we do have to slice the array so it can be passed to `next`.
        } else {
          // Create a slice.
          var slice = object.slice(spliceBegin, spliceEnd);
          // And pass it to `next`.
          var _newSlice = next(slice);
          // Splice in the new array.
          newArray.splice.apply(newArray, [spliceBegin, slice.length].concat(toConsumableArray(_newSlice)));
        }
        return newArray;
      }
      throw new Error(getTypeErrorMessage('$slice', 'array', object));
    }
  });
};

var $first = $nav(function (seq) {
  if (!seq || (typeof seq === 'undefined' ? 'undefined' : _typeof(seq)) !== 'object') {
    throw new Error(getTypeErrorMessage('$first', 'object', seq));
  }
  if (Array.isArray(seq)) {
    return [0];
  }
  for (var key in seq) {
    if (seq.hasOwnProperty(key)) {
      return [key];
    }
  }
  return undefined;
});

var $last = $nav(function (seq) {
  if (!seq || (typeof seq === 'undefined' ? 'undefined' : _typeof(seq)) !== 'object') {
    throw new Error(getTypeErrorMessage('$last', 'object', seq));
  }
  if (Array.isArray(seq)) {
    return [seq.length - 1];
  }
  var keys = Object.keys(seq);
  return keys[keys.length - 1];
});

var identity$1 = function identity(v) {
  return v;
};

var $pushContext = function $pushContext(key) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity$1;
  return $setContext(key, function (obj, ctx) {
    return (ctx[key] || []).concat(fn(obj, ctx));
  });
};

// Core API

exports.select = select$1;
exports.find = find$1;
exports.has = has$1;
exports.update = update$1;
exports.set = set$2;
exports.apply = apply$1;
exports.$each = $each;
exports.$eachKey = $eachKey;
exports.$eachPair = $eachPair;
exports.$apply = $apply;
exports.$set = $set;
exports.$none = $none;
exports.$default = $default;
exports.$merge = $merge;
exports.$mergeDeep = $mergeDeep;
exports.$begin = $begin;
exports.$end = $end;
exports.$pick = $pick;
exports.$slice = $slice;
exports.$first = $first;
exports.$last = $last;
exports.$setContext = $setContext;
exports.$pushContext = $pushContext;
exports.$nav = $nav;
exports.$lens = $lens;
exports.$traverse = $traverse;
exports.isReduced = isReduced;

Object.defineProperty(exports, '__esModule', { value: true });

})));
